import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../Services/shared.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { firstValueFrom, Observable, Subject,takeUntil} from 'rxjs';
import { Location } from '@angular/common';
import { PAGEI } from '../../models/page_config_json';
import { trigger, transition, style , animate} from '@angular/animations';
import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MobileScreenComponent } from '../mobile-screen/mobile-screen.component';
import { CATEGORIES_META_DATA } from '../../constants/widgets_meta_config_cnsts';
import { SidenavContentListComponent } from '../sidenav-content-list/sidenav-content-list.component';
import { LAST_SELECTED_OPTION,PAGETYPES,SIDENAV_DATA_MODULES } from '../../constants/proj.cnst';
import { VlDataService, VlHttpService, HTTPAPIConfig, APIConfigMapping, ApiconfigService, APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS, AppPermissionsPipe } from 'shared-library';


@Component({
  selector: 'lib-upcoming-feature',
  templateUrl: './upcoming-feature.component.html',
  styleUrls: ['./upcoming-feature.component.scss'],
  providers: [AppPermissionsPipe],
  animations: [
    trigger('sidenavFadInOut', [
      transition(':enter', [
        style({opacity: 0,transform: 'translateX(-100px)'}),
        animate('200ms', style({ opacity: 1,transform: 'translateX(0px)' })),
      ]),
      transition(':leave', [
        style({opacity: 1, transform: 'translateX(0px)'}),
        animate('200ms', style({ opacity: 0,transform: 'translateX(-100px)' }))
      ])
    ]),
    trigger('sidenavFadOutIn', [
      transition(':enter', [
        style({opacity: 0,transform: 'translateX(100px)'}),
        animate('200ms', style({ opacity: 1,transform: 'translateX(-0px)' })),
      ]),
      transition(':leave', [
        style({opacity: 1, transform: 'translateX(0px)'}),
        animate('200ms', style({ opacity: 0,transform: 'translateX(100px)' }))
      ])
    ]),
  ]
})
export class UpcomingFeatureComponent implements OnInit,OnDestroy{

  sideNavOptions = SIDENAV_DATA_MODULES;
  displaySidenavContent!:boolean;
  displaySidenavContentList!:boolean;
  pages1!: PAGEI[];
  applicationId!:string;
  breadcrumbs$!: Observable<{ id: any; label: any, state: any }[]>;
  filteredBreadcrumbs$:any
  defaultPages:any;
  paramsData: any;
  apiTab:boolean = false;
  todo: any = CATEGORIES_META_DATA;
  @ViewChild('mobileScreen') childComponent!: MobileScreenComponent;
  @ViewChild('sideNav') sideNavComponent!: SidenavContentListComponent;
  breadcrumbData:any;
  isWidthApplied:boolean=false;
  currentActiveContent:string='';
  spinner:boolean = false;
  pageTypes = PAGETYPES;
  destroy$:Subject<void> = new Subject();

    appPermissions = APP_BUILDER_PERMISSIONS;
      permissionsActions = PERMISSIONS_ACTIONS;
   
  constructor(private sharedService: SharedService,private route: ActivatedRoute,
    private router: Router,
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private location: Location,
    private apiConfigService:ApiconfigService,
        private appPermissionsPipe: AppPermissionsPipe,
    ) {
  }

  moveItemToDone(event: any) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    const newIndexInDestination = event.currentIndex;
    const newlyAddedItem = event.container.data[event.currentIndex];
  }

  moveItemToTodo(event: any) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    const newIndexInDestination = event.currentIndex;
    const newlyAddedItem = event.container.data[event.currentIndex];
    if(newlyAddedItem?.formId && newlyAddedItem?.applicationId){
      const updatedArray = event.container.data;
      let selectedpage = this.sharedService.getSelectedPage();
      let index = selectedpage.forms.findIndex((form :any) => form.formConfig.formType === 'section');
      if(selectedpage.pageType === "PreviewPage" && index >= 0){
        this.sharedService.updateFormWidgetsRemapCode(updatedArray,selectedpage.forms[index].formId);
      }else{
      this.sharedService.updateFormWidgetsRemapCode(updatedArray)
      }
    }else{
    this.todo[newlyAddedItem?.index].items?.push(newlyAddedItem)
    this.childComponent.onDrop(newlyAddedItem,newIndexInDestination)
    }
  }

  async ngOnInit() {  
    this.spinner = true;
    this.routeSubscriptions();
    await this.builderSetter();
    this.observableSubscriptions();

    this.breadcrumbData = JSON.parse(localStorage.getItem('mobileMeta') ?? '')
    this.sharedService.setSidenavContentlistOption('',false);
    if(!this.paramsData?.['pageId']){
      if(this.appPermissionsPipe.transform([this.appPermissions.viewPages, this.permissionsActions.read])){      
        this.defaultPages = await this.sharedService.getAlldefaultPages(this.paramsData?.['id']);
          if(this.defaultPages.length != 0){
            const loginPage = this.defaultPages.find((page:any) => page.pageType === "SplashScreenPage");
            this.pageDetailsSetter(loginPage);
          }
      }
    }

    const fullPath = this.location.path();
    const containsMobile = fullPath.includes('/mobile');
    if(containsMobile){
      const appInfo = this.sharedService.getApplicationDataById();
      if(appInfo === undefined){
        const existBreadcrumb = this.sharedService.getCurrentBreadcrumb();
        if(existBreadcrumb.length > 3){
          const newExitsBreadcrumb  = existBreadcrumb.slice(0,3);
          this.sharedService.updateBreadcrumb(newExitsBreadcrumb);
        }
      }     
      if(appInfo !== undefined){
        const existBreadcrumb = this.sharedService.getCurrentBreadcrumb();
        if(existBreadcrumb.length > 2){
          const newExitsBreadcrumb  = existBreadcrumb.slice(0,2);
          this.sharedService.updateBreadcrumb(newExitsBreadcrumb);
        }
        const currentBreadcrumb = this.sharedService.getCurrentBreadcrumb();
        const newBreadcrumbObj = { id: appInfo.application_id, label: appInfo.application_name, state: 'mobile' };
        const newBreadcrumb = [...currentBreadcrumb, newBreadcrumbObj];
        this.sharedService.updateBreadcrumb(newBreadcrumb);
      }
    } 
    this.breadcrumbs$ = this.sharedService.getBreadcrumb();

    this.setLastSelectedOption();
    this.spinner = false;
  }

  async builderSetter(){
    await this.loadApplicationAndTheme();
    this.apiConfigService.getAllApisResquest();
  }

  async loadApplicationAndTheme() {
    try {
      const applicationDetails = await firstValueFrom(this.getApplicationById(this.applicationId));
      this.sharedService.setApplicationDataById(applicationDetails);
      this.sharedService.setApplicationDataEntire(applicationDetails);
      this.sharedService.updateApplicationName(applicationDetails.application_name)
      const data:any = await firstValueFrom(this.getThemeData());
      const themeData = {
        primaryColor: data.primary_color,
        secondaryColor: data.secondary_color,
        defaultBackgroundColor: data.background_color,
        defaultTextColor: data.text_color,
        headingFont: data?.font_heading,
        bodyFont: data?.font_body,
        themeName: data?.theme_name,
      };
      this.sharedService.updateWholeTheme(themeData);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  routeSubscriptions(){
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params: Params) => {
      this.applicationId=params?.['id']
      this.paramsData = params;
    })
  }

  observableSubscriptions(){
    //application name subscription
    this.sharedService.currentApplicationName$.pipe(takeUntil(this.destroy$)).subscribe((appName: string) => {
      if (this.breadcrumbData) {
        this.breadcrumbData.mobileApplicationName = appName;
        localStorage.setItem("mobileMeta", JSON.stringify(this.breadcrumbData));;
      }
    });

    // selected side nav option subscription
    this.sharedService.selectedOption$.pipe(takeUntil(this.destroy$)).subscribe(option => {
      option?.label == this.sideNavOptions.metrics ? this.isWidthApplied = true : this.isWidthApplied = false;
      option?.label == this.sideNavOptions.api ? this.apiTab = true : this.apiTab = false;
      this.displaySidenavContent = false;
      this.displaySidenavContent = option.isActive;
      this.currentActiveContent = option.label;
      localStorage.setItem(LAST_SELECTED_OPTION, option.label);
      
    });
    // sidenav content list
    this.sharedService.sidenavContentlistSubject$.pipe(takeUntil(this.destroy$)).subscribe(options => {
      this.displaySidenavContentList = options.isActive
    })
  }

  pageDetailsSetter(loginPage:any) {
    const currentParams = { ...this.route.snapshot.queryParams };
    currentParams["pageId"] =loginPage?.pageId;
    this.router.navigate([], {  
      relativeTo: this.route,
      queryParams: currentParams,
      queryParamsHandling: "merge",
    });
  }

  getApplicationById(id:string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_APPLICATION']);
    apiConfig.postData = {
      id: id
    }
    apiConfig.options = {
      params: {
        "is_web":"true",
      }
    }
    return this.httpService.placeAPICall(apiConfig)
  }

  getThemeData(){
    this.sharedService.clearThemeData();
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_THEME_BYID']);
    apiConfig.postData = {
      "id": this.sharedService.getApplicationDataById()?.theme_id,
    }
    return this.httpService.placeAPICall(apiConfig)
  }
  
  onClickBreadcrumb(breadcrumbValue: any, index: any){
    this.sharedService.navigateByBreadcrumb(breadcrumbValue, index);
  }

  capitalizeWords(inputString: string): string {
    const words = inputString.split(' ');
    const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    const capitalizedString = capitalizedWords.join(' ');
    return capitalizedString;
  }


  onCanvasClick(event: MouseEvent): void {
    const lastSelectedOption = localStorage.getItem(LAST_SELECTED_OPTION) || 'Pages';
    const notAllowedPageTypes = [this.pageTypes.dataListView,this.pageTypes.loginPage,this.pageTypes.previewPage,this.pageTypes.splashScreen]
    let obj = this.sharedService.getSelectedOption();
    let selectedpage:any = this.sharedService.getSelectedPage() ?? {};
    let objOptions = this.sharedService.getSidenavContentlist();
    if(!obj.isActive ){
      this.sharedService.setSelectedOption(lastSelectedOption,true);
    }
    const currentOption = obj.isActive ? obj.label : lastSelectedOption;
    this.sharedService.setSidenavContentlistOption('addComponent',false);
    if(currentOption === 'Pages' && !notAllowedPageTypes.includes(selectedpage.pageType)){
      const shouldToggle = obj.isActive ? !objOptions.isActive : true;
      if(this.appPermissionsPipe.transform([this.appPermissions.editPage,this.permissionsActions.edit])){
        this.sharedService.setSidenavContentlistOption('addComponent',shouldToggle);
      }
    }
  }

  onComponentClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  onClickBreadcrumbUpdate(name:any){
    if(name=='home'){
      this.router.navigate(['home'])
    } else{
      this.router.navigate(['home','applications'],{ queryParams: { id:this.breadcrumbData?.id,projectName:this.breadcrumbData?.projectName } })
    }
  }

  setLastSelectedOption(){
    const option = localStorage.getItem(LAST_SELECTED_OPTION);
    if(option && option !== 'lastSelectedOption' && option != 'default'){
      this.sharedService.setSelectedOption(option,true);
    }else{
      if(this.appPermissionsPipe.transform([this.appPermissions.viewPages, this.permissionsActions.read])){
        this.sharedService.setSelectedOption("Pages",true);
      }
    }
  }

  ngOnDestroy(): void {
    localStorage.removeItem('appDetails');
    this.sharedService.resetSelectedApplicationData();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
